module.exports = __webpack_public_path__ + "img/BILLING_ADDRESS_UPDATE.png";